/**
 * Gemini 이미지 모델이 `imageConfig.aspectRatio` 로 받는 비율 enum (2.5·3.x 공통).
 * outputAspect 는 이 중 하나로 정규화돼야 Gemini 호출에 전달된다 — 스냅 없이 정확 일치만.
 */
export const GEMINI_ASPECT_RATIOS = [
    "1:1",
    "2:3",
    "3:2",
    "3:4",
    "4:3",
    "4:5",
    "5:4",
    "9:16",
    "16:9",
    "21:9",
];
function gcd(a, b) {
    return b === 0 ? a : gcd(b, a % b);
}
/**
 * `{ w, h }` 를 gcd 로 약분해 Gemini enum 값으로 변환. 지원하지 않는 비율(5:7 등)은 null.
 * 정수가 아니거나 0 이하면 null.
 */
export function toGeminiAspectRatio(aspect) {
    if (!aspect)
        return null;
    const { w, h } = aspect;
    if (!Number.isInteger(w) || !Number.isInteger(h) || w <= 0 || h <= 0) {
        return null;
    }
    const g = gcd(w, h);
    const key = `${w / g}:${h / g}`;
    return GEMINI_ASPECT_RATIOS.includes(key)
        ? key
        : null;
}
/** Gemini enum 값 → `{ w, h }`. admin select 에서 저장값으로 변환할 때 사용. */
export function fromGeminiAspectRatio(ratio) {
    const [w, h] = ratio.split(":").map(Number);
    return { w, h };
}
export const HARM_CATEGORIES = [
    "HARM_CATEGORY_HATE_SPEECH",
    "HARM_CATEGORY_DANGEROUS_CONTENT",
    "HARM_CATEGORY_HARASSMENT",
    "HARM_CATEGORY_SEXUALLY_EXPLICIT",
];
export const HARM_THRESHOLDS = [
    "BLOCK_NONE",
    "BLOCK_ONLY_HIGH",
    "BLOCK_MEDIUM_AND_ABOVE",
    "BLOCK_LOW_AND_ABOVE",
    "OFF",
];
export const GEMINI_IMAGE_SIZES = [
    "0.5K",
    "1K",
    "2K",
    "4K",
];
/** 저장 레코드에 imageSize가 없을 때(구버전 레코드) 런타임이 적용하는 기본값. */
export const DEFAULT_GEMINI_IMAGE_SIZE = "2K";
export const DEFAULT_GEMINI_CONFIG = {
    id: "default",
    model: "gemini-3.1-flash-image",
    maxRetries: 3,
    retryDelays: [2000, 5000, 10000],
    timeoutMs: 180_000,
    outputAspect: { w: 3, h: 4 },
    imageSize: DEFAULT_GEMINI_IMAGE_SIZE,
    updatedAt: "1970-01-01T00:00:00.000Z",
};
//# sourceMappingURL=gemini-config.js.map